<template>
  <b-container>
    <b-card>
      <div id="widget"></div>
    </b-card>
  </b-container>
</template>
<script>
export default {
  name: "opportunities",
  data() {
    return {
      projectId: null,
      showQuote: false,
      quoteWidget: null,
    };
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
  },
  mounted() {
    let self = this;
    setTimeout(function () {
      document.getElementById(
        "widget"
      ).innerHTML = `<mobysuite-opportunities customer="${self.customer}" version="${self.gcVersion}"><mobysuite-opportunities>`;
      let script = document.createElement("script");
      script.src = "https://cdn.mobysuite.com/opportunities/js/app.js";
      document.getElementById("widget").appendChild(script);
    }, 500);
  },
};
</script>
